import { Button, Col, Container, Form, Modal, ModalHeader, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../services/api'
import { useState, useRef, useEffect } from 'react'
import { useLoading } from '../../hooks/LoadingContext'
import { errorApi } from '../../utils/errorApi'
import ConfirmationModal from '../ConfirmationModal'

import styles from './styles.module.css'
import { IMaskInput } from 'react-imask'
import { states } from '../../utils/states'

const StoreRequestModal = ({ isOpen, onClose, onStore }) => {
  const [invoice, setInvoice] = useState('')
  const [requestNumber, setRequestNumber] = useState('')
  const [invoiceNumber, setInvoiceNumber] = useState('')
  const [cep, setCep] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [neighborhood, setNeighborhood] = useState('')
  const [street, setStreet] = useState('')
  const [streetNumber, setStreetNumber] = useState('')
  const [weight, setWeight] = useState()
  const [weightString, setWeightString] = useState('')
  const [startDate, setStartDate] = useState('')
  const [complement, setComplement] = useState('')
  const [phone, setPhone] = useState('')
  const [receiverName, setReceiverName] = useState('')
  const [note, setNote] = useState('')
  const [isInternalTransfer, setIsInternalTransfer] = useState(false)

  const invoiceInputRef = useRef(null)

  const { isLoading, setIsLoading } = useLoading()

  const [showRedoRequestModal, setShowRedoRequestModal] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        invoiceInputRef.current?.focus() // Foca no input de nota fiscal ao abrir modal
      }, 300)
    }
  }, [isOpen])

  const isValidModel = () => {
    if (
      !(
        invoice &&
        city &&
        state &&
        neighborhood &&
        street &&
        streetNumber &&
        weight &&
        receiverName
      )
    )
      return false
    return true
  }

  const clearFields = () => {
    setInvoice('')
    setRequestNumber('')
    setInvoiceNumber('')
    setCep('')
    setCity('')
    setState('')
    setNeighborhood('')
    setStreet('')
    setStreetNumber('')
    setWeight('')
    setWeightString('')
    setStartDate('')
    setComplement('')
    setPhone('')
    setReceiverName('')
    setNote('')
  }

  const handleSubmit = async (redo) => {
    setIsLoading(true)
    try {
      let modelObj = {
        status: 'unallocated',
        invoice: invoice,
        request_number: requestNumber,
        invoice_number: invoiceNumber,
        cep: cep,
        city: city,
        state: state,
        neighborhood: neighborhood,
        street: street,
        street_number: streetNumber,
        complement: complement,
        phone: phone,
        receiver_name: receiverName,
        weight: weight,
        start_date: startDate ? new Date(startDate).toISOString() : '',
        note: note,
        is_internal_transfer: isInternalTransfer,
      }

      let apiUrl = '/delivery-manager/requests'
      if (redo) apiUrl += '?redo_request=true'

      const { data } = await api.post(apiUrl, modelObj)
      toast.info('Pedido cadastrado com sucesso!')

      if (onStore) await onStore(data)
      if (redo) setShowRedoRequestModal(false)
      setIsLoading(false)

      clearFields()
      onClose()
    } catch (err) {
      const returnError = errorApi(err, 'Falha ao cadastrar o pedido! Verifique os dados.')
      if (returnError === 'Já existe uma requisição de entrega com este número de nota fiscal.') {
        setShowRedoRequestModal(true)
      }
      toast.error(returnError)
      setIsLoading(false)
    }
  }

  return (
    <Modal centered show={isOpen} onHide={() => [clearFields(), onClose()]} size="xl">
      <ModalHeader closeButton>
        <h2 style={{ textAlign: 'center', width: '100%', margin: 0 }}>Novo pedido</h2>
      </ModalHeader>
      <Container>
        <Col className={styles.formContainer}>
          <Row>
            <Col md={6}>
              <Form.Label className={styles.label}>Nota fiscal*</Form.Label>
              <Form.Control
                ref={invoiceInputRef}
                className={styles.input}
                placeholder="Digite aqui a nota fiscal"
                value={invoice}
                onChange={(event) => setInvoice(event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Form.Label className={styles.label}>Peso total do pedido (kg)*</Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask={[
                  {
                    mask: Number,
                    radix: ',',
                  },
                ]}
                placeholder="Digite aqui o peso"
                value={weightString}
                onChange={(event) => {
                  setWeightString(event.target.value)
                  setWeight(Number(event.target.value.replace(',', '.')))
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Cidade*</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cidade"
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Estado*</Form.Label>
              <Form.Select
                className={styles.input}
                value={state}
                onChange={(event) => setState(event.target.value)}
              >
                <option value="">Selecione o estado</option>
                {states.map((state) => (
                  <option key={state}>{state}</option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Rua*</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a rua"
                value={street}
                onChange={(event) => setStreet(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Bairro*</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o bairro"
                value={neighborhood}
                onChange={(event) => setNeighborhood(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Número*</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o número"
                value={streetNumber}
                onChange={(event) => setStreetNumber(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>CEP</Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask="00000-000"
                placeholder="Digite aqui o CEP"
                value={cep}
                onChange={(event) => setCep(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Complemento</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o complemento"
                value={complement}
                onChange={(event) => setComplement(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Nome do destinatário*</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome do destinatário"
                value={receiverName}
                onChange={(event) => setReceiverName(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Telefone do destinatário</Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask={[
                  { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                  { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                ]}
                placeholder="Digite aqui telefone"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Data de início da entrega</Form.Label>
              <Form.Control
                className={styles.input}
                type="date"
                min={new Date().toISOString().split('T')[0]}
                placeholder="Selecione a data"
                value={startDate}
                onChange={(event) => setStartDate(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Número do pedido</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o número do pedido"
                value={requestNumber}
                onChange={(event) => setRequestNumber(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Número da nota fiscal</Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o número da nota fiscal"
                value={invoiceNumber}
                onChange={(event) => setInvoiceNumber(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} style={{ marginTop: 20 }}>
              <Form.Switch
                className={styles.label}
                label="É transferência interna?"
                checked={isInternalTransfer}
                onChange={() => {
                  setIsInternalTransfer(!isInternalTransfer)
                }}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Observação
              </Form.Label>
              <Form.Control
                className={styles.input}
                as="textarea"
                rows={2}
                placeholder="Digite uma observação a respeito da entrega (opcional)"
                value={note}
                onChange={(event) => setNote(event.target.value)}
              />
            </Col>
          </Row>

          <Col style={{ marginTop: 15, textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={() => handleSubmit(false)}
            >
              Cadastrar pedido
            </Button>
          </Col>
        </Col>
      </Container>
      <ConfirmationModal
        show={showRedoRequestModal}
        message="Já existe uma requisição de entrega cadastrada com a nota fiscal informada. Ela é uma reentrega causada por um problema na entrega (ocorrência)?"
        action={() => handleSubmit(true)}
        closeModal={() => setShowRedoRequestModal(false)}
      ></ConfirmationModal>
    </Modal>
  )
}

export default StoreRequestModal
